module.exports = __webpack_public_path__ + "static/v1Res1-f74613ade56e67cf68ff501859d553db.png";